import { render } from "./listManufacturer.vue?vue&type=template&id=e1fafb7c"
import script from "./listManufacturer.vue?vue&type=script&lang=js"
export * from "./listManufacturer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__